import React, { useEffect, useState } from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutDoctor from './components/AboutDoctor';
import Groom from './components/Groom';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import AOS from 'aos';
import 'aos/dist/aos.css';
import PatientGallery from './components/PatientGallery';
import BlogSection from './components/BlogSection';
import VisitUs from './components/VisitUs';
import ChatBot from './components/ChatBot';
import AppointmentForm from './components/AppointmentForm';

function App() {
  const [showOffer, setShowOffer] = useState(true);

  useEffect(() => {
    AOS.init({ duration: 1000 });

    const handleScroll = () => {
      const heroSection = document.querySelector('.hero-section');
      if (!heroSection) return;

      const heroBottom = heroSection.getBoundingClientRect().bottom;

      if (heroBottom > 0) {
        setShowOffer(true);
      } else {
        setShowOffer(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {showOffer && (
        <div className="floating-offer">
         <strong> ✨ Exclusive Dental Offers & Smile Packages”</strong>
          <button
            onClick={() => {
              const herosection = document.querySelector('.groom-offer');
              const section = herosection ? herosection : document.querySelector('.groom-offer');
              if (section) section.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            View Offers
          </button>
        </div>
      )}

      <Header />
      <HeroSection />
      <AboutDoctor />
      <Services />
      <Groom />
      <Testimonials />
      <PatientGallery />
      <VisitUs />
      <BlogSection />
      <AppointmentForm />
      <footer>
        <ChatBot />
      </footer>
      <div className="footer-content">
        <p>&copy; 2025 Dr. Srishti Clinic. All rights reserved.</p>
        <p>www.srishtidentistry.com</p>
      </div>
    </>
  );
}

export default App;
